module.exports = __webpack_public_path__ + "static/media/filterIcon.6101d064.svg";